module.exports = __webpack_public_path__ + "img/Telediagnosebewertungen-green.e8a10f49.svg";